import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=19c706b9"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=19c706b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports